import _ from 'lodash'
import queryString from 'query-string'

const ENV = {}
_.forEach(process.env, (val, key) => {
  ENV[key.replace('REACT_APP_', '')] = val
})

// if whitelisted param exists in querystring then use it to override the configs
// the querystring params are case-insensitive
const whitelist = ['API_URL','DEBUG']
const qs = queryString.parse(window.location.search, { arrayFormat: 'bracket'})
const params = _.reduce(qs, (res, value, key) => {
  let upperKey = _.toUpper(key)
  if (_.indexOf(whitelist, upperKey) !== -1) {
    res[upperKey] = value
  }
  return res
}, {})

const defaults = {
  AVAILABLE_LOCALES: ['en', 'tw', 'cn'],
  DEFAULT_LOCALE: 'tw',
  FETCH_ORDER_STATUS_INTERVAL: 60000,
  // API_URL: 'http://172.19.0.114:3000',
  // API_URL: 'http://localhost:3000',
  // API_URL: 'https://omcc-test-api.tofugearapps.com',
  API_URL: 'https://omcc-uat-api.t4g.me',
  API_CHANNEL: 'cdb',
  // RSVP_API_URL: 'http://172.19.0.114:3002',
  RSVP_FRONTEND_URL: 'http://localhost:8080',
  BAG_FEE_THRESOLD: 680,
  BAG_FEE: 1,
  DEBUG: false,
  MAX_CART_SELECT_QUANTITY: 3,
  EVENT_CODE: 'rou',
  FETCH_SKU_PAGE_SIZE: 50,
  /**
   * enable start button in check in page
   * main for test before CoCo GameCenter Event, change url manually to browse product
   */
  ENABLE_START: true,
  /**
   * if you would like to test GA in local environment then please put
   * it in your .env.development.local file, example:
   *
   *   REACT_APP_GA_TRACKING_ID=UA-12345678-9
   */
  GA_TRACKING_ID: '',
  GA_TRACKING_DEBUG_MODE: true,
  GA_TRACKING_PATH_PREFIX: '/minicart',
  CONTENT_GROUPS: [
    'web_cart_ntp_hot_items',
  ],
  ORDER_READY_FLASH_MESSAGE_DURATION: 10800000, // open the flash message for 3 hours if not dimiss by user
  ...ENV,
  ...params
}

export default class Config {
  static get(key) {
    let value = defaults[key]
    switch (true) {
      case _.isInteger(value):      value = parseInt(value, 10); break
      case /true|on/.test(value):   value = true; break
      case /false|off/.test(value): value = false; break
      default: break
    }
    return value
  }

  static getAll() {
    return Object.keys(defaults).reduce((a,b) => {
      a[b] = Config.get(b)
      return a
    }, {})
  }
}

// expose as global __CONF__ variable if in debug mode!
if (Config.get('DEBUG')) {
  window.__CONF__ = Config
}



// WEBPACK FOOTER //
// ./src/configs/index.js